/**
 * SolicitudesAprobacionApiClient -- la bandeja de aprobaciones contra NexoAPI.
 *
 * MISION/TAREA: [PANEL-NOTIF-T1]. Contrato APR-T1 (Argy-D), servido por
 * SolicitudesAprobacionController. Medido el 15-sep sin credencial: las dos
 * rutas responden 401 y sus pares inventados de misma forma 404.
 *
 * El cuerpo del veredicto lo arma application/aprobaciones/solicitudes.js:
 * un solo sitio conoce el contrato de escritura.
 *
 * @module infrastructure/api/SolicitudesAprobacionApiClient
 */

import { ApiBase } from './ApiBase.js';
import { cuerpoDelVeredicto } from '../../application/aprobaciones/solicitudes.js';

const BASE = '/api/v1/solicitudes-aprobacion';

export const SolicitudesAprobacionApiClient = {
  /**
   * Todas las solicitudes del negocio (sin filtro de tipo: el API valida el
   * filtro contra 4 tipos y la caja ya manda 7). pageSize 200 es el tope del API.
   * @returns CrudResult con data = cuerpo JSON {success, data:{items,total,...}}
   */
  async listar(businessId) {
    return ApiBase.get(`${BASE}?businessId=${encodeURIComponent(businessId)}&page=1&pageSize=200`);
  },

  /**
   * Aprueba o rechaza. Lanza si los datos no cumplen el contrato, ANTES de
   * gastar el viaje.
   */
  async resolver(syncId, datos) {
    const cuerpo = cuerpoDelVeredicto(datos);
    return ApiBase.post(`${BASE}/${encodeURIComponent(syncId)}/resolver`, cuerpo);
  }
};
